/**
 * GSM-7: only ASCII printable + newline/carriage return (English/GSM-7 chars).
 * Any other character forces UCS-2 encoding.
 */
const GSM7_REGEX = /^[\x20-\x7E\n\r]*$/;

const GSM7_SINGLE_SEGMENT = 160;
const GSM7_MULTI_FIRST = 160;
const GSM7_MULTI_NEXT = 153; // UDH uses 7 chars

const UCS2_SINGLE_SEGMENT = 70;
const UCS2_MULTI_FIRST = 70;
const UCS2_MULTI_NEXT = 67; // UDH for concatenation

export function isGsm7(text: string): boolean {
  return GSM7_REGEX.test(text);
}

/**
 * Returns number of SMS segments for the given message text.
 * - GSM-7: 160 chars per segment (first), 153 for each additional.
 * - UCS-2 (non-GSM-7): 70 chars per segment (first), 67 for each additional.
 */
export function getSmsSegmentCount(text: string): number {
  if (!text || text.length === 0) return 0;
  const len = text.length;
  if (isGsm7(text)) {
    if (len <= GSM7_SINGLE_SEGMENT) return 1;
    return 1 + Math.ceil((len - GSM7_MULTI_FIRST) / GSM7_MULTI_NEXT);
  }
  if (len <= UCS2_SINGLE_SEGMENT) return 1;
  return 1 + Math.ceil((len - UCS2_MULTI_FIRST) / UCS2_MULTI_NEXT);
}

export const SMS_PRICE_PER_SEGMENT = 0.0431;

export function getEstimatedSmsPrice(userCount: number, segmentCount: number): number {
  return userCount * segmentCount * SMS_PRICE_PER_SEGMENT;
}
